module.exports = __webpack_public_path__ + "img/insurance-logo-4.aa4b7e03.png";